// import { ContentCut } from '@mui/icons-material';
import {
	ListItemIcon,
	ListItemText,
	Menu as MUIMenu,
	MenuItem as MUIMenuItem,
	MenuItemProps as MUIMenuItemProps,
	MenuProps as MUIMenuProps,
	Typography,
} from '@mui/material';
import { useState } from 'react';
import { IconNames } from '../Icon/baseTypes';
import Icon from '../Icon/Icon';
import React from 'react';
import CircularProgressBar from '../ProgressBar/CircularProgressBar';

type MenuBase = Pick<MUIMenuProps, 'onClick' | 'className'>;
type MenuItemBase = Pick<MUIMenuItemProps, 'value' | 'onClick'>;

export interface MenuProps extends MenuBase {
	id?: string;
	onClick?: any;
	menu: MenuListProps[];
	LabelComponent: React.ReactNode;
	btnStyle?: any;
	onClickMenuItem?: any;
	loading?: boolean;
	disabled?: boolean;
	closeOnItemClick?: any;
	menuItemStyle?: any;
	itemDisabled?: boolean;
	highlightItemOnSelect?: boolean;
}

interface MenuListProps {
	label: string;
	icon?: IconNames | string;
	subText?: string;
	onClick?: () => any;
	selected?: boolean;
}

export interface MenuItemProps extends MenuItemBase {
	children?: string;
	label: string;
	subText?: string;
	onClick?: any;
	menu: MenuListProps[];
}

const Menu = ({
	id = 'menu',
	menu,
	LabelComponent,
	onClick,
	btnStyle,
	onClickMenuItem,
	closeOnItemClick,
	loading,
	disabled,
	menuItemStyle,
	itemDisabled = false,
	highlightItemOnSelect = false,
	...rest
}: MenuProps) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.stopPropagation();
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<div id={id}>
			<Typography
				sx={{
					...btnStyle,
				}}
				onClick={handleClick}>
				{LabelComponent}
			</Typography>
			<MUIMenu anchorEl={anchorEl} {...rest} onClose={handleClose} open={open}>
				{menu?.map(
					(item: any): JSX.Element => (
						<MUIMenuItem
							disabled={item?.disabled || itemDisabled || false}
							id={item?.id || item?.label}
							sx={menuItemStyle}
							selected={highlightItemOnSelect ? item?.selected ?? false : false}
							onClick={(e) => {
								onClickMenuItem(item.label);
								handleClose();
								if (item?.onClick) {
									item?.onClick();
								}
								e.stopPropagation();
							}}
							key={item.label}>
							{item?.icon && (
								<Icon
									iconName={item?.icon}
									sx={{
										paddingRight: '1rem',
									}}
								/>
							)}
							{item?.img && (
								<ListItemIcon>
									<img src={item?.img} alt='img' />
								</ListItemIcon>
							)}
							{loading && (
								<CircularProgressBar style={{ width: '25px', height: '25px', marginRight: 15, color: '#4f4b4b' }} variant='indeterminate' />
							)}
							<ListItemText
								style={{ pointerEvents: disabled || item?.disabled ? 'none' : 'auto', opacity: disabled ? 0.5 : 1 }}
								primary={item?.label}
								secondary={item?.subText}
							/>
						</MUIMenuItem>
					),
				)}
			</MUIMenu>
		</div>
	);
};

Menu.defaultProps = {
	onClick: () => {},
	subText: '',
	btnStyle: { background: 'none' },
	onClickMenuItem: () => {},
	closeOnItemClick: false,
};
export default Menu;
